import { SetState } from 'zustand';
import { NotesQueryDetailsFragment } from 'generated/graphql';
import { UpdateNotesQueryState } from 'stores/interfaces/UpdateQueryState';

export const createUpdateNotesQuerySlice = (set: SetState<UpdateNotesQueryState>) => ({
  setInitialStateWithProps: (queryDetails: NotesQueryDetailsFragment) =>
    set({
      documentNumber: queryDetails.documentNumber,
      component: queryDetails.component,
      documentType: queryDetails.documentType,
      worklist: queryDetails.worklist,
      documentResponsible: queryDetails.documentResponsible
    })
});
